import { createSlice } from "@reduxjs/toolkit";

const productSlice = createSlice({
  name: "product",
  initialState: {
    GuideStatsToggleStatus: "Info",
    data: [],
    ProductID: "",
    ProductDetails: {},
  },
  reducers: {
    setGuideToggleStatus(state, action) {
      state.GuideStatsToggleStatus = action.payload;
    },
    setProductDetails(state, action) {
      state.ProductDetails = action.payload;
    },
    addProductID(state, action) {
      state.ProductID = action.payload;
    },
    addProduct(state, action) {
      const allProducts = action.payload;
      return { ...state, ...allProducts };
    },
  
    editProduct(state: any, action) {
      // console.log(JSON.parse(JSON.stringify(item)));
      return {
        ...state,
        data: state.data.map((product) =>
          product.slug === action.payload.slug
            ? { ...product, ...action.payload }
            : product
        ),
      };
    },
    deleteProduct(state, action) {},
    getAllProducts() {},
    setProducts(state, action) {
      const allProducts = action.payload;
      return { ...state, ...allProducts };
    },
  },
});

export const {
  addProduct,
  getAllProducts,
  editProduct,
  setProducts,
  setGuideToggleStatus,
  deleteProduct,
  addProductID,
  setProductDetails,
} = productSlice.actions;

export default productSlice.reducer;
